/* eslint-disable no-underscore-dangle */
import { isEmpty, get } from 'lodash';
import constants from '../utils/constants';

const { obj: { BASE_URL, ENV } } = constants;

/**
 * Generic catch function for promises
 *
 * @param {string} message
 * @param {boolean} includeError whether to include the error or not
 */
const _catch = (message = '', includeError = false) => {
  const returnObj = { success: false };
  return (error) => {
    if (message) {
      returnObj.message = message;
    }
    if (includeError) {
      returnObj.error = error;
    }
    return returnObj;
  };
};

/**
 * Get only data from response data
 *
 * @param {object} response
 */
const _dataOnly = ({ data }) => data;

/**
 * Get status only from response data
 *
 * @param {object} response
 */
const _statusOnly = ({ status }) => status;

/**
 * Handler axios errors
 *
 * @param {object} error
 */
const _errorHandler = (error) => {
  const response = get(error, 'response', {});
  const { status } = response;

  if (isEmpty(response)) {
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject({ statusText: 'Client Error' });
  }

  switch (status) {
    case 401: {
      // for local development build
      if (ENV === 'development') {
        const timeoutPath = `${BASE_URL}/login?sessionTimeout=true`.replace(/\/{2,}/g, '/');
        window.location = `http://localhost:8080${timeoutPath}`;
      } else {
        window.location = `${BASE_URL}/login?sessionTimeout=true`.replace(/(\/){2,}/g, '/');
      }
      return Promise.reject(new Error('Session timed out'));
    }

    default: {
      return Promise.reject(response);
    }
  }
};

const serviceHelpers = {
  _catch,
  _dataOnly,
  _errorHandler,
  _statusOnly,
};

export default serviceHelpers;
